module.exports = __webpack_public_path__ + "static/media/04-park-default.4d58d229.png";